{
  "400": {
    "forbidden": "Forbidden",
    "forbidden_desc": "You have no access to this page, please contact your fleet manager.",
    "forbidden_note": "(Syncing new permissions can take up to 30 minutes.)",
    "log_out": "Log out",
    "retry": "Retry"
  },
  "404": {
    "back_button": "Back to Overview",
    "contact_support": "contact support",
    "go_home": "Go to homepage",
    "not_found": "Page not found",
    "not_found_description": "The page you are looking for might have been removed had its name changed or is temporarily unavailable.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "title": "This page’s gone fishing."
  },
  "administration": {
    "billing": {
      "billing_details": "Billing Details",
      "bus": "Bus",
      "city": "City",
      "city_required": "City field is required",
      "company_name": "Company name",
      "country": "Country",
      "edit_billing_details": "Edit Billing Details",
      "edit_method": "Edit details",
      "email_address": "email address",
      "name_required": "Name field is required",
      "nr": "Nr",
      "nr_required": "Nr is required",
      "postal_code": "Postal code",
      "postal_required": "Postal code field is required",
      "save_details": "Save billing details",
      "save_method": "Save details",
      "street": "Street",
      "street_required": "Street field is required",
      "vat": "Vat"
    },
    "invoices": {
      "no_invoice_rights": "You do not have the rights to view invoices. Please contact your administrator.",
      "partial_load": "Some invoices could not be loaded",
      "invoices": "Invoices",
      "archived_invoices": "Archived Invoices",
      "downloaddetails": "Download Details Summary",
      "downloaddetailscsv": "Download Details Summary in CSV",
      "actions": "Actions",
      "amount": "Amount",
      "columns": {
        "date_range": "Date",
        "invoice_nr": "Invoice Nr",
        "status": "Status"
      },
      "date": "Date",
      "download": "Download invoice",
      "downloadattachment": "Download CDRs ",
      "due_date": "Due Date",
      "invoice_date": "Invoice date",
      "invoice_nr": "Invoice NR",
      "invoice_page": "Invoice overview",
      "no_invoices_found": "No Invoices found",
      "open": "Open",
      "open_amount": "Open amount",
      "pay_invoice": "Pay invoice",
      "payment_status": {
        "open": "Open",
        "paid": "Paid",
        "pending": "Pending"
      },
      "status": "status",
      "total": "Total"
    },
    "order": {
      "actions": "actions",
      "activate_sim": "Activate a SIM",
      "activate_sim_now": "Activate sim now",
      "active": "Active",
      "approve_installation": "Approve installation",
      "available_sims": "SIMS available:",
      "bulk": {
        "address_title": "Delivery address",
        "amount": "amount",
        "amount_label": "amount",
        "beneficiary": "Beneficiary",
        "btn_place": "Place order",
        "confirm_message": "You are about to order {amount} SIM cards. Are you sure? Please verify the details below:",
        "max_error": "Amount must be equal to or below {max}",
        "min_error": "Amount must be equal to or above {min}",
        "order_title": "Bulk order SIM Cards",
        "success_message": "Thank you for your request. The SIM cards will be delivered by mail.",
        "title_confirm": "Confirm order",
        "title_success": "Order placed"
      },
      "bulk_order_sim": "Bulk Order SIM",
      "create_ticket": "Create Ticket",
      "customer_nr": "customer n°",
      "date": "date",
      "description": "Comment",
      "download": "Download",
      "download_pdf": "Download pdf",
      "ended": "ended",
      "filter": "Search...",
      "id": "ID",
      "included_options": "Included options",
      "install": {
        "cancelled": "Cancelled",
        "fulfilled": "Fullfilled",
        "pending": "Pending"
      },
      "installation_date": "Installation dates:",
      "invoice_address": "Invoice address",
      "invoice_customer": "Invoice customer",
      "no_order_found": "No Orders found",
      "offer": "offerte",
      "offerte": "Offer",
      "order": "Order",
      "order_date": "ORDER DATE",
      "order_id": "order Id",
      "order_new_sim": "Order New SIM Card(s)",
      "order_new_subscription": "Order New subscription",
      "order_overview": "Order overview",
      "partner": "Partner",
      "pending": "pending",
      "pending_action": "Pending action",
      "select_sim": "Select a SIM Card from the list below",
      "status": "status",
      "statuses": {
        "awaiting": "Waiting for fulfillment completion",
        "fullfilled": "Fullfilled",
        "installation": "Installation",
        "ordered": "Quotation",
        "processed": "Waiting for approval",
        "shipped": "Waiting for fulfillment initiation"
      }
    },
    "usage": "Usage Details"
  },
  "cards": {
    "Download_our_citymesh_connect_app": "Download our Citymesh Connect App",
    "above_average": "above average",
    "available": "Available",
    "below_average": "below average",
    "by_email": "by email",
    "by_post": "by post",
    "call": "Call",
    "called": "called",
    "calling": "Calling",
    "cease_your_subscription": "Cease your subscription",
    "change_your_internet": "Change your internet subscription",
    "chromecast_smart_tv": "Watch online television without Smart TV with Google Chromecast",
    "company": "Company",
    "data_mb": "Data (MB)",
    "days_left": "days left",
    "details": "Details",
    "disabled": "Disabled",
    "enabled": "Enabled",
    "fiber_content": "Fiber, the network of the future, is expanding",
    "in_bundle": "In bundle",
    "international": "International",
    "internet_speed": "What internet speed do you need",
    "invoice_reminders": "Invoice reminders",
    "is_due": "is Due",
    "method": "Details",
    "mobile_data": "Mobile data",
    "mobile_usage": "Mobile usage",
    "month": "month",
    "more_info": "More info",
    "move_your_internet": "Move your internet subscription",
    "nat_eu": "National + EU",
    "no": "No",
    "only_change_request": "This data can only be changed on request",
    "open_amount": "Open amount",
    "out_of_bundle": "Out of bundle",
    "pay_now": "Pay now",
    "payment_services": "Payment services",
    "peppol": "Peppol",
    "peppol_active": "by Peppol",
    "peppol_id": "Peppol ID",
    "premium": "Premium",
    "prevent_losing_time": "How to prevent losing time & money by an internet outage",
    "roaming_out": "Roaming(Out of EU)",
    "select_usage_type": "Select an usage type",
    "sent": "sent",
    "sepa_desc": "Set up SEPA payments to ensure you never miss a due date",
    "settings": "Settings",
    "shortcuts": "Shortcuts",
    "slip_your_bill": "Don't let bills slip your mind",
    "speedtest": "Speedtest",
    "stay_in_the_know": "Stay in the know",
    "tips_tricks": "Tips & Tricks",
    "total_out_of_bundle_cost": "Total out of bundle cost",
    "usage": "usage",
    "usage_history": "Usage History",
    "usage_statistics": "Usage statistics",
    "usage_type": "Usage type",
    "used": "used",
    "voice_min": "Voice (min)",
    "wifi6_ready": "Are your ready for WIFI6?!",
    "yes": "Yes"
  },
  "countries": {
    "belgium": "Belgium",
    "france": "France",
    "germany": "Germany",
    "luxembourg": "Luxembourg",
    "netherlands": "Netherlands"
  },
  "customer": {
    "ID": "ID"
  },
  "customer_select": {
    "select_customer": "Please select a customer"
  },
  "dashboard": {
    "Welcome back": "Welcome back",
    "leaderboard": {
      "cost": "Cost",
      "name": "Name",
      "rank": "Ranking",
      "title": "Top 5 Users",
      "usageOrder": {
        "Cost": "Cost",
        "Volume": "Volume"
      },
      "usageType": {
        "MOBILE_DATA_BELGIUM": "Mobile Data Belgium",
        "MOBILE_DATA_ROAMING_EU": "Mobile Data Roaming EU",
        "MOBILE_DATA_ROAMING_ROW": "Mobile Data Roaming ROW",
        "SMS_BELGIUM": "SMS Belgium",
        "SMS_PREMIUM": "Premium SMS",
        "SMS_ROAMING_EU": "SMS Roaming EU",
        "SMS_ROAMING_ROW": "SMS Roaming ROW",
        "SMS_TO_INTERNATIONAL": "SMS to International",
        "VOICE_BELGIUM": "Voice Belgium",
        "VOICE_INTERNATIONAL": "Voice to International",
        "VOICE_PREMIUM": "Premium Voice",
        "VOICE_ROAMING_EU": "Voice Roaming EU",
        "VOICE_ROAMING_ROW": "Voice Roaming ROW"
      },
      "volume": "Volume"
    },
    "products": {
      "title": "Your subscriptions or connections"
    }
  },
  "error": {
    "customer_select_title": "Invalid request",
    "unknown_customer_id": "Oups, we couldn't quite serve this request. Please select a customer. You can switch between customers via the top right menu.",
    "wrong_customer_id_redirect": "Oups, we couldn't quite serve this request."
  },
  "filter": {
    "add_filter": "Add filter",
    "contains": "contains",
    "is": "is",
    "is_after": "is after",
    "is_before": "is before",
    "is_not": "is not",
    "range": "range",
    "status": {
      "1": "In progress",
      "2": "On Hold",
      "3": "Completed",
      "4": "Follow up",
      "21": "To Do",
      "22": "Customer reply needed",
      "Completed": "Completed",
      "Customer reply needed": "Customer reply needed",
      "CustomerReplyNeeded": "Customer reply needed",
      "Follow up": "Follow up",
      "FollowUp": "Follow Up",
      "In progress": "In progress",
      "InProgress": "In Progress",
      "On hold": "On Hold",
      "OnHold": "On Hold",
      "Open": "Open",
      "Paid": "Paid",
      "To do": "To Do",
      "ToDo": "To Do",
      "open": "Open",
      "paid": "Paid"
    }
  },
  "global": {
    "activate": "Activate",
    "active": "Active",
    "cancel": "Cancel",
    "cancelled": "cancelled",
    "click_for_details": "Click for details",
    "click_to_hide": "Click to collapse",
    "close": "Close",
    "confirm": "Confirm",
    "confirm_title": "Are you sure?",
    "connection_error_message": "We cannot establish a connection to Citymesh.com",
    "connection_error_title": "No Connection",
    "cookie_policy": "Cookie policy",
    "day": "day",
    "deactivate": "Deactivate",
    "email_required": "Email is required",
    "email_valid": "Email must be valid",
    "fetching": "fetching",
    "general_conditions": "General conditions",
    "go_to_page": "go to page",
    "inactive": "Inactive",
    "loading": "Loading",
    "month": "month",
    "no_results": "No results",
    "of": "of",
    "offline": "offline",
    "ok": "Ok",
    "online": "online",
    "pending": "pending",
    "powered_by": "Powered by",
    "privacy_policy": "Privacy policy",
    "required_field": "field is required",
    "results": "results",
    "retry_connection": "Retry connection",
    "showing": "showing",
    "invalid_phone_format": "invalid phonenumber",
    "invalid_email": "invalid email"
  },
  "language": {
    "French": "Frans",
    "dutch": "Nederlands",
    "english": "English"
  },
  "language_selector": {
    "language": "Language"
  },
  "menu": {
    "404": "404",
    "auth": "Auth",
    "billing": "Billing Details",
    "buttons": "Buttons",
    "dashboard": "Dashboard",
    "faq": "FAQ",
    "home": "Home",
    "login": "Login",
    "payment-methods": "Payment methods",
    "payments": "Payments",
    "preferences": "Account preferences",
    "pricing-plans": "Pricing plans",
    "projects": "Projects",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "settings": "Application settings",
    "signup": "Signup",
    "timelines": "Timelines",
    "users": "Users"
  },
  "menu_side": {
    "administration": "Administration",
    "agreements": "Agreements",
    "billing": "Billing Details",
    "commissions": "Commissions",
    "deals": "Deals",
    "documents": "Documents",
    "home": "Home",
    "internet": "Internet",
    "invoices": "Invoices",
    "mind": "Mind",
    "mindinvoices": "Invoices",
    "mobile": "Mobile",
    "orders": "Orders",
    "overview": "Overview",
    "partner": "Partner",
    "products": "Products",
    "support": "Support",
    "tools": "Tools",
    "unauthorized": "403",
    "usermanagement": "User Management",
    "usage": "Usage"
  },
  "message": {
    "usage_history": "Usage history"
  },
  "partner": {
    "addresstool": {
      "name": "customer name",
      "title": "Partnertools",
      "warning": "The speeds shown are informative and have no contractual value.",
      "box": "Box",
      "city": "City",
      "expectedfiber": "Expected fiber speeds:",
      "expectedinternet": "Expected internet speeds:",
      "fiber": "GPON",
      "invalid_request": "Invalid Request",
      "internet": "VDSL",
      "linetest": "VDSL / GPON",
      "coaxtest": "Coax",
      "fibertest": "Fiber",
      "maxdownload": "Max download speed:",
      "maxspeed": "Max speed:",
      "maxupload": "Max upload speed:",
      "nodata": "No data found for that address",
      "technology_not_available": "Sorry, the requested technology is not available at this address. Please try Coax or Fiber address check.",
      "number": "Number",
      "result": "Your Result",
      "run": "Run",
      "street": "Street",
      "validation": {
        "invalid_city": "Invalid city name",
        "invalid_format": "Invalid format (use letters or common symbols)",
        "invalid_number": "Invalid house number",
        "invalid_zip": "Invalid ZIP code format",
        "numeric_only": "Field must contain only numbers",
        "required": "Field is required"
      },
      "zipcode": "ZIP code",
      "ticket_created": "Ticket {id} has been created. We will get back to you within 5 days.",
      "customerName": "Customer Name"
    },
    "agreements": {
      "title": "Agreements",
      "upload": "upload"
    },
    "commissions": {
      "csv": "csv",
      "pdf": "pdf",
      "title": "Commission overview"
    },
    "deals": {
      "confirm": "Confirm",
      "close": "Close",
      "cancel": "Cancel Deal",
      "upload_contract": "Upload Contract",
      "select_contract": "Select contract",
      "upload": "Upload",
      "upload_contract_required": "Please select a contract",
      "upload_contract_invalid_type": "Only PDF, PNG, JPG and JPEG files are allowed",
      "upload_contract_too_large": "The contract cannot exceed 20 MB",
      "upload_contract_size": "{size}/{max} MB",
      "upload_contract_success": "Upload Successful",
      "upload_contract_failed": "Upload Failed",
      "cancel?": "Are you sure you want to cancel this deal?",
      "cancel_success": "Deal successfully canceled",
      "action": "action",
      "reason": "Reason",
      "address": "address",
      "company": "company",
      "companynr": "Company Number",
      "date": "date",
      "deal_overview": "Deal Registration Overview",
      "deals": "deals",
      "description": "Comments",
      "email": "email",
      "file": "Files",
      "register": "Register",
      "firstname": "Prospect First Name",
      "lastname": "Prospect Last Name",
      "name": "name",
      "new_claim": "New Deal",
      "new_deal": "Register Deal",
      "phonenumber": "Phone number",
      "solution": "Solution",
      "solution_other": "Other solution",
      "solution_options": {
        "mobile": "Mobile",
        "internet": "Internet",
        "ucaas": "UCaaS",
        "fixed_telephony": "Fixed Telephony",
        "other": "Other"
      },
      "status": "status",
      "statuses": {
        "requested": "Requested",
        "active": "Active",
        "pending": "Pending",
        "expired": "Expired",
        "won": "Won",
        "rejected": "Rejected",
        "cancelled": "Cancelled"
      },
      "submit": "create new claim",
      "ticket": "ticket",
      "info_succes": "claim succesfull",
      "info_fail": "claim unsuccesfull",
      "dealid": "claim ID",
      "title_success": "Deal registered successfully",
      "title_fail": "Deal registration failed",
      "claimed_until": "claimed until",
      "nodeals": "No deals found"
    },
    "documents": {
      "filter": {
        "contract": "Contract",
        "marketing": "Marketing",
        "pricelist": "Price List",
        "productsheet": "Product Sheet",
        "none": "None",
        "general": "General",
        "other": "Other"
      },
      "contracttemplates": "Contract templates",
      "documents": "My Documents",
      "pricelists": "Price lists",
      "productlists": "Product lists",
      "submit": "submit",
      "title": "My Documents",
      "file": "File",
      "filetype": "Filetype",
      "type": "Type",
      "doctype": {
        "general": "General",
        "personal": "Personal"
      },
      "category": "Category",
      "date": "Date",
      "action": "Action",
      "nodocs": "No document found"
    }
  },
  "userManagement":{
    "noUsers": "No user found",
    "userEmail": "Email",
    "userFullName": "Full name",
    "userRole": "Role",
    "userStatus": "Status",
    "userInvitedOn": "Invited on",
    "userLastLoggedIn": "Last logged in",
    "userSplitBilling": "Split billing",
    "actions": "Actions",
    "resendInvite": "Resend invitation",
    "userReinviteSent": "Reinvite sent successfully",
    "userReinviteFailed": "Failed to send reinvite",
    "inviteNewUser": {
      "inviteUserTitle": "Invite user",
      "userEmail": "Email",
      "userFirstName": "First name",
      "userLastName": "Last name",
      "userLanguage": "Language",
      "userRole": "Role",
      "inviteUserButton": "Invite user",
      "inviteUserSuccess": "User invited successfully.",
      "fleetManagerRole": "Fleet manager",
      "simManagerRole": "SIM manager",
      "invoiceManagerRole": "Invoice manager",
      "endUserRole": "End User",
      "missingCredentials": "Authentication credentials were missing or invalid.",
      "insufficientPermissions": "You do not have permission to create users.",
      "userAlreadyExists": "An account with this email address already exists in the identity provider.",
      "wrongEmailFormat": "The email format is invalid.",
      "unexpectedServerError": "Unexpected server error.",
      "languageEn": "English",
      "languageNl": "Dutch",
      "languageFr": "French",
      "editUserTitle": "Edit user",
      "editUserSuccess": "User updated successfully.",
      "editUserFailed": "Failed to update user."
    }
  },
  "payment": {
    "btn_ok": "ok",
    "info_fail": "We didn't receive your payment. Please try again our contact our support department.",
    "info_success": "We received your payment correctly. Note that it can take up to 30 minutes before the open amount is updated.",
    "title_fail": "Payment failed",
    "title_success": "Payment received"
  },
  "product": {
    "barrings": {
      "title": "Barrings"
    },
    "mobile": {
      "options": "Options"
    },
    "usage_warnings": {
      "title": "Usage warnings"
    }
  },
  "products": {
    "active": "Active",
    "cancelled": "cancelled",
    "filter": "Search ...",
    "inactive": "Inactive",
    "internet": {
      "actions": "actions",
      "address": "address",
      "available": "Available",
      "bus": "Bus",
      "circuit_id": "Circuit id",
      "connection": "connection",
      "connection_interrupted": "Your internet connection will be interrupted for a few seconds, when ipv6 is activated",
      "details": "Details",
      "down": "Down",
      "enable_ipv6": "Enable IPV6",
      "internet_overview": "Internet overview",
      "internet_usage": "Internet usage",
      "ip": "IPv4",
      "label": "label",
      "no_internet_found": "No Internet subscriptions found",
      "password": "Password",
      "password_modem": "If you change your password here, please also change it in the configuration of your router.",
      "profile": "Profile",
      "select_subscriber": "Select an subscriber",
      "settings": "Settings",
      "start": "Start",
      "status": "status",
      "subscription": "subscription",
      "type": "Type",
      "up": "Up",
      "usage_statistics": "Usage Statistics",
      "username": "Username"
    },
    "internet_usage": "Internet usage",
    "mobile": {
      "simtype": "SIM type",
      "esim": "eSIM",
      "psim": "Physical SIM",
      "IMSI_number": "SIM nr",
      "actions": "actions",
      "activate_calls_prem_numbers": "Calls to premium services possible",
      "activate_inter_calls": "International calls possible",
      "activate_out_of_bundle_sms": "Activate out of bundle SMS",
      "activate_prem_numbers": "Activate Calls premium numbers",
      "activating_option": "We are activating the add-on, this may take a moment…",
      "activation_date": "Activation date",
      "activation_success_reference": "Order reference: {orderId}",
      "activation_success_title": "Add-on activated successfully",
      "addon_2292": "On the Citymesh network, you will always enjoy the best 4G and 5G speeds.<br />Today, we are not yet able to cover the entire country with our own network.<br />If you would like to use 5G on our partner Proximus’ network as well, <strong>please choose a 5G option.</strong><br /><a href=\"https://www.citymesh.be/en/network-service\" target=\"_blank\">More information about the Citymesh network.</a>",
      "addon_2294": "On the Citymesh network, you will always enjoy the best 4G and 5G speeds.<br />Today, we are not yet able to cover the entire country with our own network.<br />If you would like to use 5G on our partner Proximus’ network as well, <strong>please choose a 5G option.</strong><br /><a href=\"https://www.citymesh.be/en/network-service\" target=\"_blank\">More information about the Citymesh network.</a>",
      "addon_2295": "On the Citymesh network, you will always enjoy the best 4G and 5G speeds.<br />Today, we are not yet able to cover the entire country with our own network.<br />If you would like to use 5G on our partner Proximus’ network as well, <strong>please choose a 5G option.</strong><br /><a href=\"https://www.citymesh.be/en/network-service\" target=\"_blank\">More information about the Citymesh network.</a>",
      "amount": "amount",
      "bundle_name": "Bundle name",
      "confirm_activate": "This will activate his mobile subscription, are you sure?",
      "confirm_activate_option": "This will activate option {name} which will add a {price} fee to your monthly subscription",
      "confirm_activate_option_title": "Are you sure?",
      "confirm_deactivate": "This will de-activate this mobile subscription, it will not be usable anymore, are you sure?",
      "confirm_deactivate_option": "This will de-activate option {name} which will remove a {price} fee to your monthly subscription",
      "confirm_sim_swap": "You are about to request a SIM Swap, we will send you a new SIM Card replacing your current one, are you sure?",
      "confirm_suspend": "This will temporarely suspend this mobile subscription, it will not be usable, are you sure?",
      "details": "Details",
      "end_date": "end date",
      "fist_warning_sms": "1st warning via SMS on",
      "gb_data": "GB DATA",
      "id": "nr",
      "info_out_of_bundle": "You are currently {amount} over your limit. Try decreasing your data usage.",
      "info_reach_bundle": "you are about to reach your limit. Try decreasing your data usage.",
      "label": "label",
      "limits": "Limits",
      "minutes": "Minutes",
      "mobile_data": "Mobile Data",
      "mobile_data_usage": "mobile data usage",
      "mobile_overview": "Mobile overview",
      "mobile_phone_number": "Mobile phone number",
      "msisdn": "MSISDN",
      "no_mobile_subscription": "No mobile subscriptions found",
      "no_subscription_found": "No mobile subscriptions, found",
      "out_of_bundle_cost": "Out of bundle cost",
      "phone_from": "Phone from",
      "price": "Price",
      "puk1": "PUK1",
      "puk2": "PUK2",
      "request_failed": "Request failed",
      "request_success": "Request successfully sent",
      "temporarily_unavailable": "Temporarily unavailable",
      "no_order_permission": "You do not have permission to order options.",
      "order_in_progress": "Order in progress",
      "order_in_progress_blocked": "An option order is still in progress. You can order a new option once it is completed.",
      "second_warning_sms": "2nd warning via SMS on",
      "settings": "Settings",
      "settings_updated": "settings updated",
      "simnumber": "Sim Nr",
      "sms": "sms",
      "split_bill_status": "Split-bill status",
      "split_bill_type": "Split-bill type",
      "start_date": "start date",
      "status": "Status",
      "subscription": "subscription",
      "subscription_name": "subscription name",
      "suspend": "Suspend",
      "termination_date": "Termination date",
      "text_copied": "text copied!",
      "unlimited": "∞",
      "update_settings": "Update settings",
      "upgrade": "upgrade",
      "usage_warnings": "Usage warnings"
    },
    "pending": "pending",
    "status": {
      "Created": "Created",
      "Ended": "Ended",
      "Fulfilled": "Fulfilled",
      "OrderCancelled": "Order Cancelled",
      "OrderRejected": "Order Rejected",
      "QuotationRejected": "Quotation Rejected",
      "Removed": "Removed",
      "WaitingForCleanupApproval": "Waiting For Cleanup Approval",
      "WaitingForCleanupCompletion": "Waiting For Cleanup Completion",
      "WaitingForCleanupInitiation": "Waiting For Cleanup Initiation",
      "WaitingForFulfillmentCompletion": "Waiting For Fulfillment Completion",
      "WaitingForFulfillmentInitiation": "Waiting For Fulfillment Initiation",
      "WaitingForOrderApproval": "Waiting For Order Approval"
    },
    "status_group": {
      "Active": "Active",
      "Inactive": "Inactive",
      "Terminated": "Terminated"
    },
    "support": {
      "export_all": "All tickets",
      "export_filtered": "Filtered tickets"
    },
    "terminated": "Terminated",
    "usage_details": "Usage details"
  },
  "sim_swap": "Swap",
  "support": {
    "Field_is_required": "Field is required",
    "You": "You",
    "archived": "Archived",
    "attachments": "Attachments",
    "category": "Category",
    "chat_with_us": "Chat with us!",
    "citymesh_support": "Citymesh Support",
    "closed_on": "Closed on",
    "commercial": "Commercial",
    "content": "Content",
    "create_ticket": "Create Support Ticket",
    "created_by": "Created by",
    "date": "Created Date",
    "default": "Default",
    "department": "Department",
    "export": "Export",
    "file_too_large": "File \"{fileName}\" is too large. Maximum size is {maxSize} MB.",
    "filter": "Search",
    "finance": "Finance",
    "helpdesk": "Helpdesk",
    "label": "Label",
    "message": "Message",
    "monitor_connections": "Network Monitoring",
    "new_support_ticket": "New Support Ticket",
    "no_product": "None",
    "no_support": "No support tickets found",
    "nohistory": "This support ticket is still empty",
    "order": "Order",
    "other": "Other",
    "priorities": {
      "p1": "Urgent (P1)",
      "p2": "High (P2)",
      "p3": "Medium (P3)",
      "p4": "Low (P4)"
    },
    "priority": "Priority",
    "priority_number": {
      "1": "P1",
      "2": "P2",
      "3": "P3",
      "4": "P4"
    },
    "product": "Product",
    "resolution": "Resolution",
    "search_option": "Select an option",
    "select_column": "Select a column",
    "select_operator": "Select a operator",
    "select_option": "Select an option",
    "select_value": "Select a value",
    "send": "Send",
    "status": "Status",
    "subject": "Subject",
    "support_ticket": "Support ticket",
    "ticket": {
      "info_fail": "Something went wrong while creating your ticket, try again later",
      "info_success": "Your ticket is created",
      "p1_contact": "You made a high priority ticket: contact us on +32 2 580 91 00 so we can follow up immediately",
      "ticket_number": "ticket number",
      "title_fail": "Unable to create ticket",
      "title_success": "Ticket created"
    },
    "ticketId": "TicketID",
    "ticket_id": "ticket id",
    "ticket_status": {
      "1": "In progress",
      "2": "On Hold",
      "3": "Completed",
      "4": "Follow up",
      "21": "To Do",
      "22": "Customer reply needed",
      "Completed": "Completed",
      "Customer reply needed": "Customer reply needed",
      "Follow up": "Follow up",
      "In progress": "In progress",
      "On hold": "On Hold",
      "To do": "To Do"
    },
    "time": {
      "day": "day",
      "hour": "h",
      "month": "month",
      "week": "week",
      "year": "year"
    },
    "time_opened": "TTR",
    "time_opened_tooltip": "Time to resolve",
    "times": {
      "day": "days",
      "month": "months",
      "week": "weeks",
      "year": "years"
    },
    "total_size_too_large": "Maximum allowed combined file size exceeded",
    "unsupported_file": "File \"{fileName}\" is not supported",
    "unsupported_file_type": "File type \"{fileName}\" is not supported. Allowed types are: {allowedTypes}.",
    "upload file": "Upload file",
    "urgent_question": "Urgent questions?",
    "view": "View",
    "write_answer": "Write answer",
    "zabbix": "ZABBIX",
    "zabbix_link": "Network Monitoring"
  },
  "usage": {
    "cdr_download_failed": "Record details could not be downloaded.",
    "cdr_month_too_old": "Usage data can only be exported for the last three months",
    "cdr_no_records": "No record details were found for this period.",
    "download_cdr": "Download",
    "page_title": "Usage",
    "select_product": "Select a product",
    "select_type": "Select usage type"
  },
  "user": {
    "CustomerId": "CustomerId",
    "ID": "ID",
    "account_settings": "Account settings",
    "billing": "Billing",
    "explore": "Explore",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "projects": "Projects",
    "settings": "Settings",
    "switch_to_fleetportal": "Switch to fleet portal"
  },
  "vuestic": {
    "noOptions": "No options available",
    "search": "Search"
  }
}
